import type { MRT_ColumnDef } from "mantine-react-table-open";
import type { Site } from "../../../utils/backend-types";
import type { Doc } from "../../DeliveryOverview/DeliveryOverview.types";

function getSiteColumn(sites: Array<Site>): MRT_ColumnDef<Doc> {
  return {
    header: "Liegenschaft",
    accessorKey: "site",
    accessorFn: (invoiceEntry) =>
      sites.find((site) => site.id === invoiceEntry.invoiceData?.site)?.name ||
      invoiceEntry.siteName ||
      "",
    size: 200,
    filterVariant: "multi-select"
  };
}

export { getSiteColumn };
